"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
// text field

const styleOverrides = {
  root: ({
    theme
  }) => ({
    fontSize: theme.typography.body2.fontSize,
    [`&.${_material.inputClasses.root}.${_material.inputClasses.disabled}:before`]: {
      borderBottomStyle: 'solid'
    }
  }),
  input: {
    '&&:-webkit-autofill': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }
  }
};
const defaultProps = {
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
